export default {
    inject: ['page'],
    data () {
        return {
            leilao: this.page.leilao
        }
    }
}
